var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circles"},_vm._l((_vm.sizes),function(circle,index){return _c('div',{key:index,staticClass:"circle",style:(`width: ${_vm.returnSize(index)}px; height: ${_vm.returnSize(index)}px`)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }